import { render, staticRenderFns } from "./ProductsWebsite.vue?vue&type=template&id=dd8950c2&scoped=true&"
import script from "./ProductsWebsite.vue?vue&type=script&lang=js&"
export * from "./ProductsWebsite.vue?vue&type=script&lang=js&"
import style0 from "./ProductsWebsite.vue?vue&type=style&index=0&id=dd8950c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8950c2",
  null
  
)

export default component.exports